import styled from 'styled-components';
import { themeColor } from '~/common/utils/theme';

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Option = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  min-width: 200px;
  background-color: ${themeColor('background.primary', { dark: 'background.secondary' })};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.divider.primary};
  padding: 12px 0px;
  margin-bottom: 16px;
  margin-left: 10px;
  margin-right: 10px;
  transition: all 0.3s linear;
  cursor: pointer;

  :hover {
    background-color: ${({ theme }) => theme.colors.brand.secondary};
    border-color: ${({ theme }) => theme.colors.brand.secondaryAlt};
  }

  .title {
    color: ${({ theme, success }) => (success ? theme.colors.positive.primary : theme.colors.brand.primary)};
  }

  input {
    visibility: hidden;
  }

  .img_container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 12px;

    img {
      max-height: 80px;
      max-width: 80px;
    }
  }
`;
